import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import TextIcon from '../../extension/TextIcon';
import { Menu } from 'semantic-ui-react';
import { authAPI, useCurrentUser } from '../../_services';

export const SideMenu = () => {
  const { currentUser, currentUserCan } = useCurrentUser();

  const [activeItem, setActiveItem] = useState('dashboard');
  const [smallMenu, setSmallMenu] = useState(false); // eslint-disable-line
  const [sideMenu, setSideMenu] = useState(<></>);

  useEffect(() => {
    if (!currentUser) return;

    setSideMenu(
      <Menu vertical style={{ width: '100%' }}>
        <Menu.Item
          as={NavLink}
          exact
          to={'/admin'}
          name="dashboard"
          active={activeItem === 'dashboard'}
          onClick={setActiveItem('dashboard')}
        >
          <TextIcon hideText={smallMenu} name="home">
            Dashboard
          </TextIcon>
        </Menu.Item>
        <Menu.Item
          as={NavLink}
          to={'/admin/alerts'}
          name="alerts"
          active={activeItem === 'alerts'}
          onClick={setActiveItem('alerts')}
        >
          <TextIcon hideText={smallMenu} name="bell">
            Alerts
          </TextIcon>
        </Menu.Item>

        {currentUserCan('DoAllTheThings') && (
          <>
            <Menu.Item
              as={NavLink}
              to={'/admin/audit'}
              name="audit"
              active={activeItem === 'audit'}
              onClick={setActiveItem('audit')}
            >
              <TextIcon hideText={smallMenu} name="history">
                Audit
              </TextIcon>
            </Menu.Item>
            <Menu.Item
              as={NavLink}
              to={'/admin/users'}
              name="users"
              active={activeItem === 'users'}
              onClick={setActiveItem('users')}
            >
              <TextIcon hideText={smallMenu} name="users">
                Users
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {currentUserCan('ViewCustomer') && (
          <Menu.Item
            as={NavLink}
            to={'/admin/customers'}
            name="customers"
            active={activeItem === 'customers'}
            onClick={setActiveItem('customers')}
          >
            <TextIcon hideText={smallMenu} name="users">
              Customers
            </TextIcon>
          </Menu.Item>
        )}
        {currentUserCan('ManageLance') && (
          <Menu.Item
            as={NavLink}
            to={'/admin/lances'}
            name="lances"
            active={activeItem === 'lances'}
            onClick={setActiveItem('lances')}
          >
            <TextIcon hideText={smallMenu} name="filter">
              Lances
            </TextIcon>
          </Menu.Item>
        )}
        <Menu.Item
          as={NavLink}
          to={'/admin/hubs'}
          name="hubs"
          active={activeItem === 'hubs'}
          onClick={setActiveItem('hubs')}
        >
          <TextIcon hideText={smallMenu} name="sitemap">
            HUBS
          </TextIcon>
        </Menu.Item>
        {currentUserCan('DoAllTheThings') && (
          <>
            <Menu.Item
              as={NavLink}
              to={'/admin/billing'}
              name="billing"
              active={activeItem === 'billing'}
              onClick={setActiveItem('billing')}
            >
              <TextIcon hideText={smallMenu} name="pound sign">
                Billing
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {currentUserCan('ViewPendingBills') && (
          <>
            <Menu.Item
              as={NavLink}
              to={'/admin/pending-bills'}
              name="pending-bills"
              active={activeItem === 'pending-bills'}
              onClick={setActiveItem('pending-bills')}
            >
              <TextIcon hideText={smallMenu} name="pound sign">
                Pending Bills (Old)
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {currentUserCan('ViewPendingBills') && (
          <>
            <Menu.Item
              as="a"
              href="/admin-portal?category=money_movements&transaction_types=CUSTOMER_PAYMENT&transaction_statuses=PENDING%2CFAILED&is_aon_host=false"
              name="pending-bills-new"
            >
              <TextIcon hideText={smallMenu} name="pound sign">
                Pending Bills (New)
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {currentUserCan('ViewPendingBills') && (
          <>
            <Menu.Item
              as="a"
              href="/admin-portal?transaction_statuses=PENDING%2CFAILED"
              name="transactions-new"
            >
              <TextIcon hideText={smallMenu} name="pound sign">
                All Transactions (New)
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {currentUserCan('ViewAON') && (
          <>
            <Menu.Item
              as="a"
              href="/admin-portal/accounts"
              name="home-accounts-new"
            >
              <TextIcon hideText={smallMenu} name="id card outline">
                HOME Account Management (New)
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {currentUserCan('ViewAON') && (
          <>
            <Menu.Item
              as={NavLink}
              to={'/admin/aon/postcodes'}
              name="aon-postcodes"
              active={activeItem === 'aon-postcodes'}
              onClick={setActiveItem('aon-postcodes')}
            >
              <TextIcon hideText={smallMenu} name="id card outline">
                Trojan Home Postcode Approval
              </TextIcon>
            </Menu.Item>
            <Menu.Item
              as={NavLink}
              to={'/admin/aon/surveys'}
              name="aon-surveys"
              active={activeItem === 'aon-surveys'}
              onClick={setActiveItem('aon-surveys')}
            >
              <TextIcon hideText={smallMenu} name="id card outline">
                Trojan Home Surveys
              </TextIcon>
            </Menu.Item>
          </>
        )}
        {/*<Dropdown item text="Documentation">
          <Dropdown.Menu>
            <Dropdown.Item
              icon="file"
              text="Technical Documentation"
              onClick={() => history.push(`/doc_controller`)}
            />
            <Dropdown.Item
              icon="file"
              text="Support - HUB"
              onClick={() => {
                const url = '/doc_support_hub';
                window.open(url, '_blank').focus();
              }}
            />
            <Dropdown.Item
              icon="file"
              text="Support - HOME"
              onClick={() => {
                const url = '/doc_support_aon';
                window.open(url, '_blank').focus();
              }}
            />
          </Dropdown.Menu>
        </Dropdown>*/}
        <Menu.Item
          as={NavLink}
          to={'/admin/map'}
          name="map"
          active={activeItem === 'map'}
          onClick={setActiveItem('map')}
        >
          <TextIcon hideText={smallMenu} name="map">
            Map
          </TextIcon>
        </Menu.Item>
        {currentUserCan('DoAllTheThings') && (
          <Menu.Item
            as={NavLink}
            to={'/admin/beta'}
            name="beta"
            active={activeItem === 'beta'}
            onClick={setActiveItem('beta')}
          >
            <TextIcon hideText={smallMenu} name="file">
              BETA Features
            </TextIcon>
          </Menu.Item>
        )}
        <Menu.Item
          as={NavLink}
          to={'/admin/profile'}
          name="profile"
          active={activeItem === 'profile'}
          onClick={setActiveItem('profile')}
        >
          <TextIcon hideText={smallMenu} name="id card outline">
            Profile
          </TextIcon>
        </Menu.Item>
        <Menu.Item
          as={NavLink}
          to={'/admin/logout'}
          name="logout"
          active={activeItem === 'logout'}
          onClick={() => {
            authAPI.logout();
          }}
        >
          Logout
        </Menu.Item>
      </Menu>
    );
  }, [currentUser, activeItem, smallMenu]); // eslint-disable-line

  return (
    <div id="sidebar" className="parent">
      {/*<div className={(smallMenu ? 'small-side ' : '') + 'side'}>
        {sideMenu}
      </div>*/}
      <div className={(smallMenu ? 'small-content ' : '') + 'content'}>
        {sideMenu}
      </div>
    </div>
  );
};
